import { Component, Input, OnDestroy, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';

@Component({
  selector: 'app-form-field-video',
  templateUrl: './video-form-field.component.html',
  styleUrls: ['./video-form-field.component.scss'],
  standalone: false,
})
export class VideoFormFieldComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: string;

  @Input() editMode: boolean;

  videoSrc: string;

  srcSet: boolean = false;

  matcher: MyErrorStateMatcher = null;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    return this.getValidatorConfig(v).condition(formControl);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }

  ngAfterViewInit() {
    this.srcSet = true;
    this.videoSrc = this.data;
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {}
}
